<template>
    <el-dialog class="finalizationDialog" center :title="title" width="60%" height="68%" top="3vh" append-to-body :visible.sync="visible" :close-on-click-modal="false" :before-close="handleClose">
        <div v-loading="loading" style="height: 100%;">
            <el-tabs  v-if="showTabs"  type="border-card" v-model="activeName" >
                <el-tab-pane v-for="(item, index) in protocolFileList" :key="index" :name="index+''">
                    <span slot="label" class="fileName"><i v-show="item.isRead" class="el-icon-check"></i>{{ item.fileName }}</span>
                     <iframe v-if="showTabs" :key="'protocolIframe'+ index + iframeKey" :id="'protocolIframe'+ index + iframeKey" :src="handleUrl(item.fileUrl)" frameborder="0" width="100%" height="100%" />
                </el-tab-pane>
            </el-tabs>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="medium" type="primary" :disabled="disabled" :loading="btnLoading" @click="handleConfirm">签订协议</el-button> &emsp;
            <el-button size="medium" type="text" @click="handleClose">取消</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { downloadPdf, pushElectronic } from '@/modules/transport/bms/api/settleDetails.js';
export default {
    name: 'finalizationDialog',
    components: {},
    props: {
        iframeKey: {
            type: String
        }
    },
    data() {
        return {

            title: '签订协议',
            visible: false,
            loading: false,
            btnLoading: false,
            showTabs: false,
            activeName: '0',
            params: {},
            protocolFileList: [
                {
                    fileName: '现金折扣业务申请书',
                    fileUrl: '',
                    isRead: false
                },
                {
                    fileName: '现金折扣协议',
                    fileUrl: '',
                    isRead: false
                }
            ]
        };
    },
    computed: {
        disabled: function () {
            let flag = true;
            flag = !this.protocolFileList.every((el) => el.isRead);
            return flag;
        }
    },
    methods: {
        handleClose() {
            this.visible = false;
        },
        handleTabClick() {
            this.visible = false;
        },
        handleVisible(flag, data) {
            this.visible = true;
            this.params = data;
            this.getData(data);
        },
        getData({ jobId, apApplyNo, apApplyChangeNo }) {
            const params = {
                jobId,
                apApplyNo,
                apApplyChangeNo
            };
            this.loading = true;
            downloadPdf(params).then(res => {
                if (res.code === '0') {
                    this.showTabs = true;
                    this.protocolFileList[0].fileUrl = res.data.cashDiscountApply.downUrl;
                    this.protocolFileList[1].fileUrl = res.data.applyArgeement.downUrl;
                    this.$nextTick(() => {
                        this.scrollRead();
                    });
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        scrollRead() {
            this.$nextTick(() => {
                const that = this;
                this.protocolFileList.forEach((el, index) => {
                    const iframeDom = document.getElementById('protocolIframe' + index + this.iframeKey);
                    iframeDom.onload = function (event) {
                        const iframeContentDocument = iframeDom.contentDocument;
                        const scrollBox = iframeContentDocument.getElementById('viewerContainer');
                        scrollBox.addEventListener('scroll', that.throttle(function (event) {
                            var scrollTop = scrollBox.pageYOffset || scrollBox.scrollTop;
                            var docHeight = scrollBox.scrollHeight;
                            var viewportHeight = scrollBox.innerHeight || scrollBox.clientHeight;

                            // 计算滚动条是否滚动到了页面高度的90%
                            var isScrolledToPercent = scrollTop > (docHeight - viewportHeight) * 0.7;

                            if (isScrolledToPercent) {
                                that.protocolFileList[index].isRead = true;
                            }
                        }, 10));
                    };
                });
            });
        },
        throttle(func, limit) {
            let inThrottle;
            return function() {
                const context = this;
                const args = arguments;
                if (!inThrottle) {
                    func.apply(context, args);
                    inThrottle = true;
                    // eslint-disable-next-line no-return-assign
                    setTimeout(() => inThrottle = false, limit);
                }
            };
        },
        handleConfirm() {
            const { jobId, apApplyNo, apApplyChangeNo } = this.params;
            this.btnLoading = true;
            pushElectronic({ jobId: jobId.toString(), apApplyNo, apApplyChangeNo }).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('签订协议成功');
                    this.$emit('finalizationSuccess');
                    this.visible = false;
                }
            }).finally(() => {
                this.btnLoading = false;
            }); ;
        },
        handleUrl(url) {
            const resUrl = '/pdfjs/web/viewer.html?toolbar=false&file=' + url;
            return resUrl;
        }

    },
    created() {

    },
    mounted() {
    }
};
</script>
<style lang="less" scoped>
.finalizationDialog {
    .fileName{
        .el-icon-check{
            color: #67C23A;
            font-size: 20px;
            position: relative;
            left: -5px;
            top: 2px;
        }
    }
   /deep/ .el-dialog__body{
        height: 70vh;
        .el-tabs{
            height: 100%;
            .el-tabs__content{
                box-sizing: border-box;
                height: calc(100% - 38px) ;
                padding: 0;
                .el-tab-pane{
                    height: 100%;
                }
            }
        }
    }
}
</style>
